import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';

const { FiChevronRight, FiChevronLeft } = FiIcons;

const PageLayout = ({ 
  title, 
  subtitle, 
  icon, 
  color = "text-green-700", 
  bgColor = "bg-green-50",
  children,
  prevLink,
  nextLink,
  prevLabel,
  nextLabel
}) => {
  return (
    <div className="space-y-6 fade-in pb-10">
      {/* Page Header */}
      <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm flex items-start gap-5">
        <div className={`p-4 rounded-xl ${bgColor} ${color} shadow-sm`}>
          <SafeIcon icon={icon} className="text-2xl" />
        </div>
        <div className="flex-1">
          <h1 className="heading-lg mb-2">{title}</h1>
          <p className="text-gray-500 leading-relaxed max-w-3xl">
            {subtitle}
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="min-h-[400px]">
        {children}
      </div>

      {/* Bottom Navigation */}
      {(prevLink || nextLink) && (
        <div className="grid grid-cols-2 gap-4 pt-6 mt-8 border-t border-gray-200">
          <div>
            {prevLink && (
              <Link to={prevLink} className="group flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-green-500 hover:shadow-md transition-all">
                <div className="p-2 rounded-full bg-gray-50 group-hover:bg-green-50 text-gray-400 group-hover:text-green-600 transition-colors">
                  <SafeIcon icon={FiChevronLeft} />
                </div>
                <div className="text-left">
                  <div className="text-xs text-gray-400 font-medium uppercase tracking-wider">Previous</div>
                  <div className="font-semibold text-gray-700 group-hover:text-gray-900">{prevLabel || 'Back'}</div>
                </div>
              </Link>
            )}
          </div>
          <div className="text-right">
            {nextLink && (
              <Link to={nextLink} className="group flex items-center justify-end gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-green-500 hover:shadow-md transition-all">
                <div className="text-right">
                  <div className="text-xs text-gray-400 font-medium uppercase tracking-wider">Next Lesson</div>
                  <div className="font-semibold text-gray-700 group-hover:text-gray-900">{nextLabel || 'Continue'}</div>
                </div>
                <div className="p-2 rounded-full bg-gray-50 group-hover:bg-green-50 text-gray-400 group-hover:text-green-600 transition-colors">
                  <SafeIcon icon={FiChevronRight} />
                </div>
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageLayout;